import { PropsWithChildren } from "react";
import * as OrgConfig from "src/generated/hooks/org-config/requests";
import { useOrgConfig } from "src/hooks/useOrgConfig";
import { isNullOrUndefined } from "src/services/predicates";
import { AccessDenied } from "../Feedback/AccessDenied";
import { RemoteDataView } from "../Layout/RemoteDataView";

type RequireConfigProps = PropsWithChildren<{
  configType: OrgConfig.OrgConfigType;
}>;

export const RequireConfig: React.FC<RequireConfigProps> = ({
  children,
  configType,
}) => {
  const configRD = useOrgConfig(configType);

  return (
    <RemoteDataView remoteData={configRD} error={() => null}>
      {(config) => {
        // AvelaAI and IdentityAI configs expose `enabled`; other configs use `disabled`
        let hasAccess: boolean;
        if (isNullOrUndefined(config)) {
          hasAccess = false;
        } else {
          hasAccess =
            "enabled" in config
              ? config.enabled === true
              : config.disabled !== true;
        }
        return hasAccess ? (
          <>{children}</>
        ) : (
          <AccessDenied
            message="You don't have access to this page, redirecting..."
            isRedirect={true}
          />
        );
      }}
    </RemoteDataView>
  );
};
